var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVieuniteSocialMediaIconsTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 135",
    style: {
      enableBackground: "new 0 0 135 135"
    },
    width: 40,
    height: 40,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0tt{fill:#0F1A6A;}\r\n\t.st1tt{fill:#FFFFFF;}\r\n\t.st2tt{fill:#707070;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "adedb3a4-768a-4b50-bc1e-0429aaa7a46b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0tt",
    cx: 67.4,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1tt",
    d: "M67.4,32.7c11.3,0,12.7,0,17.2,0.2c2.7,0,5.4,0.5,7.9,1.5c1.8,0.7,3.5,1.8,4.9,3.2c1.4,1.4,2.5,3,3.2,4.9 c0.9,2.5,1.4,5.2,1.4,7.9c0.2,4.5,0.2,5.8,0.2,17.2s0,12.7-0.2,17.2c0,2.7-0.5,5.4-1.5,7.9c-0.7,1.8-1.8,3.5-3.2,4.9 c-1.4,1.4-3,2.5-4.9,3.2c-2.5,0.9-5.2,1.4-7.9,1.5c-4.5,0.2-5.8,0.2-17.2,0.2s-12.7,0-17.2-0.2c-2.7,0-5.4-0.5-7.9-1.5 c-3.7-1.4-6.6-4.4-8.1-8.1c-0.9-2.5-1.4-5.2-1.5-7.9c-0.2-4.5-0.2-5.8-0.2-17.2s0-12.7,0.2-17.2c0-2.7,0.5-5.4,1.5-7.9 c1.4-3.7,4.4-6.6,8.1-8.1c2.5-0.9,5.2-1.4,7.9-1.5C54.7,32.7,56.1,32.7,67.4,32.7 M67.4,25c-11.5,0-13,0-17.5,0.2 c-3.5,0.1-7,0.8-10.3,2c-5.7,2.2-10.2,6.7-12.4,12.4c-1.2,3.3-1.9,6.8-2,10.3c-0.2,4.5-0.3,6-0.3,17.5s0.1,13,0.3,17.5 c0.1,3.5,0.8,7,2,10.3c2.2,5.7,6.7,10.2,12.4,12.4c3.3,1.2,6.8,1.9,10.3,2c4.5,0.2,6,0.3,17.5,0.3s13-0.1,17.5-0.3 c3.5-0.1,7-0.8,10.3-2c5.7-2.2,10.2-6.7,12.4-12.4c1.2-3.3,1.9-6.8,2-10.3c0.2-4.5,0.2-6,0.2-17.5s0-13-0.2-17.5 c-0.1-3.5-0.8-7-2-10.3c-2.2-5.7-6.7-10.2-12.4-12.4c-3.3-1.2-6.8-1.9-10.3-2C80.4,25,79,25,67.4,25L67.4,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1tt",
    d: "M67.4,45.7c-12.1,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8 C89.3,55.5,79.5,45.7,67.4,45.7C67.4,45.7,67.4,45.7,67.4,45.7z M67.4,81.7c-7.8,0-14.2-6.3-14.2-14.2s6.3-14.2,14.2-14.2 s14.2,6.3,14.2,14.2l0,0C81.6,75.3,75.3,81.7,67.4,81.7C67.4,81.7,67.4,81.7,67.4,81.7L67.4,81.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1tt",
    cx: 90.1,
    cy: 44.8,
    r: 5.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2tt",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1tt",
    d: "M53.9,106.4c33,0,51-27.3,51-51c0-0.8,0-1.5,0-2.3c3.5-2.5,6.5-5.7,8.9-9.3c-3.3,1.5-6.7,2.4-10.3,2.8 c3.7-2.2,6.5-5.8,7.9-9.9c-3.5,2.1-7.4,3.5-11.4,4.3c-6.8-7.2-18.1-7.6-25.3-0.8C71,43.6,69,48.3,69,53.3c0,1.4,0.1,2.7,0.5,4.1 c-14.4-0.7-27.9-7.5-37-18.7c-4.8,8.2-2.3,18.7,5.5,23.9c-2.8-0.1-5.6-0.9-8.1-2.2c0,0.1,0,0.2,0,0.2c0,8.5,6,15.9,14.4,17.6 c-2.6,0.7-5.4,0.8-8.1,0.3c2.4,7.3,9.1,12.3,16.7,12.5c-6.3,5-14.2,7.7-22.3,7.7c-1.4,0-2.9-0.1-4.3-0.2 C34.6,103.6,44.1,106.4,53.9,106.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieuniteSocialMediaIconsTwitter);
export default __webpack_public_path__ + "static/media/Vieunite Social Media Icons_Twitter.37249a159bc0b967f95fdab6f29622dd.svg";
export { ForwardRef as ReactComponent };